export default __webpack_public_path__ + "static/media/library-image-01.99767dfc.png";